import React, { useEffect } from "react";

// Type
import { ILayout } from "./type";

// Default screen height
const clientHeight = (window?.visualViewport?.height || 0);

export const Layout: React.FC<ILayout> = ({ children }) => {
  const handlerError = (e: any) => {
    if (/Loading chunk [\d]+ failed/.test(e.message)) {
      window.location.reload();
    }
  };

  useEffect(() => {
    window.addEventListener("error", handlerError);
    window?.visualViewport?.addEventListener("resize", viewportHandler);

    return () => {
      window.removeEventListener("error", handlerError);
      window?.visualViewport?.removeEventListener("resize", viewportHandler);
    };
  }, []);

  function viewportHandler() {
    const html = document.querySelector("html");
    if ((window?.visualViewport?.height || 0) > clientHeight) {
      if (html) {
        html.style.cssText = "font-size:10px !important";
      }
    } else {
      if (html) {
        html.style.cssText = "";
      }
    }
  }

  return (
    <main>
      {children}
    </main>
  );
};

export default Layout;